define('glu/grid/filter/enumSearch',['require','./fieldSearch','../../util','../../flexDropdown','hbs!./enumSearch.hbs'],function(require) {
    'use strict';

    var FieldSearch = require('./fieldSearch'),
        util = require('../../util'),
        FlexDropdown = require('../../flexDropdown'),
        tmpl = require('hbs!./enumSearch.hbs');

    return FieldSearch.extend({
        template: tmpl,

        regions: {
            select: '.region-enum-select'
        },

        initialize: function() {
            // this is a collection when using a server side enum
            this.enumHash = this.model.get('enumHash');

            // used for non-server data - should be a flat JSON object, NOT a collection
            // TODO an LOB who uses this should verify that it is working correctly
            this.enumData = util.result(this, 'enumHash');

            if (this.model.get('serverSideEnum')) {
                // if the collection already exists and has models, don't fetch again
                if (this.enumHash.models && this.enumHash.length) {
                    this.enumData = this.enumHash.toJSON();
                } else {
                    this.listenToOnce(this.enumHash, 'sync', this.setEnumDataAndRender);
                    this.enumHash.fetch();
                }
            }
        },

        setEnumDataAndRender: function(enumCollection) {
            this.enumData = enumCollection.toJSON();
            this.render();
        },


        createDropdown: function() {
            var dropdownData = this.buildDropdownData(),
                preSelectedIds = dropdownData.length ? [dropdownData[0].id] : [],
                value = this.model.get('value');

            if (value) {
                preSelectedIds = [value];
            }

            var dropdown = new FlexDropdown({
                data: dropdownData,
                filter: false,
                multiSelect: false,
                preSelectedIds: preSelectedIds,
                showTooltip: false,
                showCancelIcon: false,
                clearBtn: false,
                disableMultiButton: true
            });

            return dropdown;
        },

        buildDropdownData: function() {
            if (!this.model.get('serverSideEnum')) {
                return util.map(this.enumData, function(value, key) {
                    return {
                        id: value,
                        name: key || value || '' // flexdropdown checks string length on this value, cannot be undefined 
                    };
                });
            }

            // server-side enums use a collection rather than JSON
            return this.enumHash.map(function(model) {
                return {
                    id: model.get('value'),
                    name: model.get('label') || model.get('value') || ''
                };
            });
        },

        onBeforeRender: function() {
            this.initializeDropdown();
        },

        onRender: function() {
            this.showDropdown();
        },

        initializeDropdown: function() {
            this.closeDropdown(); // clean up the dropdown if one already exists
            this.dropdown = this.createDropdown();
        },

        showDropdown: function() {
            this.select.show(this.dropdown);
            this.enableSubmitButton();
        },

        enableSubmitButton: function() {
            var hasValue = this.dropdown.value('id').length;

            this.ui.$submitBtn.prop('disabled', !hasValue);
            this.ui.$clearBtn.toggleClass('hidden', !hasValue);
        },

        buildFilter: function(field, value) {
            // For enums, the label isn't the same as the selected value
            var label;

            if (this.model.get('serverSideEnum')) {
                // with server-side enums, enumHash is a collection
                var enumModel = this.model.get('enumHash').findWhere({
                    value: value
                });
                if (enumModel) {
                    label = enumModel.get('label');
                }
            } else {
                // with non-server-side enums, enumData is a name: value object
                label = util.findKey(this.enumData, function(v) {
                    return v === value;
                });
            }

            var result = {
                title: this.model.get('title'),
                value: value,
                label: label || value,
                type: 'enum',
                field: field || this.field,
                filter: util.bind(this.filter, this, this.field || field, value),
                enumHash: this.model.get('enumHash'),
                serverSideEnum: this.model.get('serverSideEnum'),
                format: this.model.get('format') // this is only applied to the filter for enum types

            };

            // if a formatter is defined, run it with the correct arguments
            // this would be a good place to call locale(), if needed
            if (util.isFunction(this.model.get('format'))) {
                var formatFunc = this.model.get('format');
                result.label = this.model.get('serverSideEnum') ? formatFunc(value, this.model) : formatFunc(value);
            }

            return result;
        },

        handleSubmit: function(e) {
            e.preventDefault();

            util.defer(function() {
                if (this.isClosed) {
                    return;
                }

                var field = this.model.get('field');
                var value = this.dropdown.value('id')[0];
                var filter = this.buildFilter(field, value);
                try {
                    this.trigger('filter', filter);
                } catch (ex) {
                    return false;
                }
                return false;
            }.bind(this));
        },

        onClose: function() {
            this.closeDropdown();
        },

        closeDropdown: function() {
            if (!this.dropdown) {
                return;
            }
            this.dropdown.close();
        }
    });
});

